import { format_order_id } from '@/website/global_function'

// สถานะของคำขอสั่งซื้อ (OrderMasterTemp) และสีที่ใช้แสดง
export const OMS_STATUS = {
  WAIT_MANAGER: 'WAIT_MANAGER',
  WAIT_ADMIN: 'WAIT_ADMIN',
  REJECTED: 'REJECTED',
  CANCELLED: 'CANCELLED',
  APPROVED: 'APPROVED'
}

export const OMS_STATUS_COLOR = {
  WAIT_MANAGER: 'orange',
  WAIT_ADMIN: 'blue',
  REJECTED: 'red',
  CANCELLED: 'grey',
  APPROVED: 'green'
}

// ลำดับแท็บในหน้ารายการ
export const OMS_STATUS_TABS = ['WAIT_MANAGER', 'WAIT_ADMIN', 'REJECTED', 'APPROVED', 'CANCELLED']

// ชื่อ field ของจำนวนต่อสถานะใน response ของ get-order-request-count
export const OMS_STATUS_COUNT_FIELD = {
  WAIT_MANAGER: 'waitManager',
  WAIT_ADMIN: 'waitAdmin',
  REJECTED: 'rejected',
  CANCELLED: 'cancelled',
  APPROVED: 'approved'
}

// เลขที่ใช้เรียกคำสั่งซื้อ: ON ใช้เลขคำขอ ODT-... ส่วน TT ไม่มีเลขคำขอ ใช้เลขออเดอร์ปกติของระบบ
export function orderNo (request) {
  if (request.requestNo) {
    return request.requestNo
  }
  return request.orderMasterID ? format_order_id(request.orderMasterID) : '#' + request.tempID
}

// key ของข้อความสถานะ: คำสั่งซื้อที่ยกเลิกหลังมีออเดอร์จริงแล้ว คือออเดอร์ถูกยกเลิกจากฝั่งคลัง ใช้ข้อความแยกจากที่ผู้สร้างยกเลิกเอง
export function statusLabelKey (request) {
  if (request.status == 'CANCELLED' && request.orderMasterID) {
    return 'status_ORDER_CANCELLED'
  }
  return 'status_' + request.status
}

export function formatOmsDatetime (value) {
  if (value == null) {
    return ''
  }
  // backend ส่งเวลาไทยแบบไม่มี timezone เช่น 2026-10-08T16:51:25.353
  const text = String(value)
  return text.substring(8, 10) + '/' + text.substring(5, 7) + '/' + text.substring(0, 4) + ' ' + text.substring(11, 16)
}
